import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LanguageSection = styled(Box)({
  padding: 0,
});

export const LanguageTabsLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  flexWrap: 'wrap',
});

export const LangCompleteBadge = styled(Box)({
  fontSize: '11px',
  fontWeight: 700,
  color: 'var(--am-success-color)',
  backgroundColor: 'var(--am-success-bg)',
  padding: '0px 4px',
  borderRadius: 3,
  lineHeight: 1.3,
});

export const LangIncompleteBadge = styled(Box)({
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--am-error-color)',
  backgroundColor: 'var(--am-error-bg)',
  padding: '0px 4px',
  borderRadius: 3,
  lineHeight: 1.3,
});

export const AutoTranslateButton = styled(Button)({
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 8,
  padding: '4px 10px',
  minHeight: 'unset',
  height: 'auto',
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  border: 'var(--am-inline-btn-border)',
  backgroundColor: 'var(--am-inline-btn-bg)',
  color: 'var(--am-inline-btn-color)',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: 'var(--am-inline-btn-hover-bg)',
    border: 'var(--am-inline-btn-border)',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    borderColor: 'var(--am-border-mid)',
    color: 'var(--am-text-primary)',
  },
});
